/**
 * Helper function for exhaustive checks of discriminated unions.
 */
export function assertNever(value) {
  throw new Error("Unhandled discriminated union member: ".concat(JSON.stringify(value)));
}